import { ThirdPartyRefundProvider } from "@redotech/redo-model/third-party-refunds/provider";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const setThirdPartyRefundProvider = {
  name: "setThirdPartyRefundProvider" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    thirdPartyRefundProvider: createEnum(ThirdPartyRefundProvider).nullish(),
  }),
  output: z.object({
    thirdPartyRefundProvider: createEnum(ThirdPartyRefundProvider).nullish(),
  }),
};
